<template>
	<c-modal @close="close" :title="title">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<div>
				<h6 class="margin-t-40 margin-b-16">Wijzig eigenaar</h6>
				<c-select
                    :label="'In gebruik door'"
                    :horizontal="true"
                    :options="contacts"
                    v-model="client_id"
                    :ValueName="'client_id'"
                    name="first_name,last_name"
                    :required="true">
                </c-select>


                <div v-if="!addNewUser">
                    <a @click="newUser"
                        class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
                        <svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20"
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <path
                                    d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1"
                                    id="plus" />
                            </defs>
                            <use fill="currentColor" fill-rule="nonzero" xlink:href="#plus" />
                        </svg>
                        <span>Maak een nieuw account</span>
                    </a>
                </div>
                <CSubForm v-if="addNewUser" name="contact">
                    <c-personal-data 
                        ref="personalform"
                        :edit="false"
                        :contact="contact"
                        title="of maak een nieuw account"
                        :without_account="true">
                    </c-personal-data>
                </CSubForm>

			</div>

			<h6 class="margin-t-40">Wijzig locatie</h6>

            <c-zipcode-address v-if="item.address"
				:label="'Postcode en hnr.'"
				:sublabel="'Bezoekadres'"
				:horizontal="true"
				:zipcode="item.address.zipcode"
				:number="item.address.number"
				:street="item.address.street"
				:city="item.address.city"
				:addition="item.address.addition !== null ? item.address.addition : ''"
				:name="item.address.name !== null ? item.address.name : ''"
				ref="address"/>

            <c-zipcode-address v-else
				:label="'Postcode en hnr.'"
				:sublabel="'Adres'"
				:horizontal="true"
				name="*"
                ref="address"/>

                <h6 class="c-text-icon margin-t-24 margin-b-16">
                    Contact gegevens
                </h6>
				<c-input
					:label="'E-mailadres'"
					:horizontal="true"
					type="text"
					name="email"
					v-model="email"
					required/>

                    <c-input
					:label="'Telefoonnummer'"
					:horizontal="true"
					type="text"
					name="phone"
					v-model="phone"
					required/>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-b-16 no-margin-b" type="submit" :disabled="submitting">Wijzigen</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CItem from '@components/Item';
import CDatepicker from '@components/form/input/Datepicker';
import CPersonalData from '@components/PersonalData';
import CZipcodeAddress from '@components/ZipcodeAddress';
import { ValidationError } from '../errors';

export default {
	mixins: [Form],
	components: {
		CModal, CItem, CDatepicker, CPersonalData, CZipcodeAddress
	},
	props: {
		title: {
			required: true
		},
        item: {
            required: true
        }
	},
	data() {
		return {
            contacts: {},
            submitting: false,
            client_id: this.item.client_id,
            contact: {},
            addNewUser: false,
            email: '',
            phone: ''
		}
	},
	methods: {
		submit() {

            let data = {
                client_id: this.client_id,
                address: this.$refs.address.getData(),
                contact: this.$refs.personalform ? this.$refs.personalform.getData() : {},
                contact_email: this.email,
                contact_phone: this.phone
            };

            if(!this.client_id && !this.addNewUser) {
                data.remove_client = true;
            }

            this.$xhr.post('/api/items/' + this.item.id + '/mutation', data).then( ({result}) => {
                this.$store.dispatch('toast/success', {title: 'Succes', text: 'Mutatie is succesvol doorgevoerd'});
                this.$emit('close');
                this.$emit('reload');
            }).catch((e) => {
                console.log(e.errors);
                if(e.errors) {
                    let errors = e.errors.contact;
                    this.$refs.form.setErrors(errors);
                }
              
                this.$refs.form.setErrors(e.errors);
                this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
            });
		},
        close() {
            this.$emit('close');
        },
        newUser(){

            this.addNewUser = true;
            this.client_id = null;
        }
	},
	mounted(){
		this.$xhr.get('/api/getendclientsdetailbyparentid/' + this.item.product.client_id).then( ({result}) => {
            this.contacts = result;
            this.contacts.unshift({
                client_id: null,
                firstname: '',
                lastname: ''
            });
        }).catch((e) => {
            this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
        });
	}
}
</script>
